import * as Yup from "yup"

export const SDPayGroupInitialValues = {
	name: "",
}

export const SDPayGroupSchema = Yup.object().shape({
	name: Yup.string().required().label("Name").trim(),
})
